export const LOCALSTORAGE_TICKET_ITEMS = "LOCALSTORAGE_TICKET_ITEMS";
export const LOCALSTORAGE_APPSTATE = "LOCALSTORAGE_APPSTATE";
export const LOCALSTORAGE_BALANCE = "LOCALSTORAGE_BALANCE";
export const LOCALSTORAGE_TICKET_CHECK = "LOCALSTORAGE_TICKET_CHECK";
export const LOCALSTORAGE_QR_INPUT = "LOCALSTORAGE_QR_INPUT";
export const LOCALSTORAGE_LAST_USER_INTERACTION =
  "LOCALSTORAGE_LAST_USER_INTERACTION";
export const LOCALSTORAGE_SHOW_ADMIN_LOGIN = "LOCALSTORAGE_SHOW_ADMIN_LOGIN";

//iz CEF-a
export const K_LOCAL_STORAGE_KEY_MACHINE_INFO =
  "K_LOCAL_STORAGE_KEY_MACHINE_INFO";



// WEBPACK FOOTER //
// ./src/HOCs/Constants/LocalStorageKeys.js